import { createContext, Dispatch } from 'react'
import { FiltersAction } from '@/modules/accredited-establishments/hooks/useFiltersReducer/useFiltersReducer.types'

const FiltersDispatchContext = createContext<Dispatch<FiltersAction>>(() => {})

export { FiltersDispatchContext }
